<template>
  <div class="rightPage">
    <div class="rightHeader">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        :inline="true"
        :optareBtn="optareBtn"
        :treePathObj="treePathObj"
        @resetFn="resetFn"
        @searchFn="searchFn"
        @confirmFn="getListFn"
        @nodeClick="nodeClick"
        @netFn="netFn"
        @stopFn="stopFn"
        @calibrationFn="calibrationFn"
        @calibrationImportFn="calibrationImportFn"
        @calibrationExpiredFn="calibrationExpiredFn"
      />
    </div>
    <!-- table -->
    <div class="componentPage">
      <unbind-table
        :loading="loading"
        ref="table"
        :tableData="tableData"
        @choozeTable="choozeTable"
        @configFn="configFn"
        @detailFn="detailFn"
        @stopUseFn="stopUseFn"
        @historyFn="historyFn"
        @calibrationSignleFn="calibrationSignleFn"
      />

      <Pager
        ref="pager"
        :total="total"
        :size="SearchForm.iDisplayLength"
        @currentChange="getListFn"
      ></Pager>
      <!--      <Pagination-->
      <!--        class="pagination"-->
      <!--        :total="total"-->
      <!--        :page.sync="SearchForm.iDisplayStart"-->
      <!--        :limit.sync="SearchForm.iDisplayLength"-->
      <!--        @pagination="getListFn"-->
      <!--      ></Pagination>-->
    </div>
    <!-- 网络参数上报规则模态框  -->
    <v-net
      :isShow.sync="isShow"
      :choozeTableData="choozeTableData"
      :useFuncId="useFuncId"
      :useFuncType="useFuncType"
      ref="vForm"
    />
    <!-- 绑定配置信息模态框 -->
    <v-config
      ref="config"
      :isShowConfig.sync="isShowConfig"
      :rowData="rowData"
      :useFuncType="useFuncType"
      v-if="isShowConfig"
      :sensorWay="sensorWay"
    />
    <!-- 详情 -->
    <v-detail
      ref="detail"
      :isShowDetail.sync="detailIsShow"
      :title="detailTitle"
      :baseMsg="baseMsg"
      :deviceType="deviceType"
      :detailObj="detailObj"
      :deviceProperty="deviceProperty"
      :detailLoading="detailLoading"
      :detailRuleObj="detailRuleObj"
      :detailNetObj="detailNetObj"
      :sensorWay="sensorWay"
      @changdetail="changdetail"
    />

    <sensorDetailDialog></sensorDetailDialog>
     <!-- 校准模态框 -->
    <CalibrationDialog
      v-if="isShowCalibration"
      :isShow.sync="isShowCalibration"
      :choozeTableData="choozeTableData"
      :rowData="rowData"
      :singleCalibration="singleCalibration"
    >
    </CalibrationDialog>
    <!-- 标准导入模态框 -->
    <CalibrationImport
      :isShow.sync="isShowCaliImport"
      :choozeTableData="choozeTableData"
    >
    </CalibrationImport>
    <!-- 标准过期模态框 -->
    <CalibrationExpired
      v-if="isShowCaliExpired"
      :isShow.sync="isShowCaliExpired"
    >
    </CalibrationExpired>
  </div>
</template>

<script>
import { sensorList } from '@/api/api'
import { sensorUpdateStatus } from '@/api/modules/sensor.js'
import qs from 'qs'
import { RunStatus } from '@/utils/icon.js'
import netParam from '../NetParam.vue'
import ConfigDialogVue from '../ConfigDialog.vue'
import tableUnBind from './UnBindTable.vue'
import detailDialog from '../DetailDialog.vue'
import { sensorHistory } from '@/utils/winDetail'
import bus from '@/utils/bus.js'
import getAllTreePath from '@/utils/getAllTreePath.js'
import sensorDetailDialog from '@/components/dialog/sensorDetail/sensorDetailDialog'
import { sensorHistoryQueryFormat } from '@/utils/simplify/query'
import { getIsPlatform, getPermission } from '@/utils/permission'
import Pager from '@/components/Pagination/src/Pager.vue'
import CalibrationDialog from '../CalibrationDialog.vue'
import CalibrationImport from '../CalibrationImport.vue'
import CalibrationExpired from '../CalibrationExpired.vue'

export default {
  name: 'bindTalbe',
  components: {
    Pager,
    'v-net': netParam,
    'v-config': ConfigDialogVue,
    'unbind-table': tableUnBind,
    'v-detail': detailDialog,
    sensorDetailDialog,
    CalibrationDialog,
    CalibrationImport,
    CalibrationExpired
  },
  props: {
    selectDeviceType: {
      type: Array
    }
  },
  watch: {
    selectDeviceType: {
      handler (newVal) {
        this.formContent[1].selectParam = newVal
      },
      immediate: true
    }
  },
  computed: {
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      return getPermission()
    }
  },

  mixins: [getAllTreePath],
  data () {
    return {
      formContent: [
        {
          id: 1,
          text: 'public.table_code',
          type: 'input',
          paramsName: 'tagId',
          isChooze: true
        },
        {
          id: 6,
          text: 'device.sensor_type',
          type: 'select',
          paramsName: 'sensorType',
          isChooze: false,
          selectParam: []
        },
        {
          id: 7,
          text: 'device.running_status',
          type: 'select',
          paramsName: 'status',
          selectParam: [...RunStatus],
          isChooze: false
        },
        {
          id: 5,
          text: 'device.forward_gateway',
          type: 'input',
          paramsName: 'gatewayName',
          isChooze: false
        }
      ],
      SearchForm: {
        tagId: null,
        scopeName: null,
        gatewayName: null,
        sensorType: null,
        status: '',
        configurate: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      total: 0,
      loading: false,
      tableData: [],
      title: '',
      isShow: false,
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.stop',
          method: 'stopFn'
        },
        {
          id: 2,
          icon: '',
          vHas: ['incubatorDelCarrier'],
          text: 'public.net_param',
          method: 'netFn'
        },
        {
          id: 3,
          icon: '',
          vHas: ['incubatorDelCarrier'],
          text: 'public.escalation_rules',
          method: 'netFn'
        }
      ],
      sensorWay: 'unbind',
      // 勾选的表格数据
      choozeTableData: [],
      // 正在使用绑定的方法操作
      useFuncId: '',
      // 区分六种情况下的表单
      useFuncType: '',
      // 配置模态框
      isShowConfig: false,
      configContent: {},
      rowData: null,
      // 点击表格的数据

      // 未确认
      isShowUnDialog: false,
      unTitle: '',
      baseMsg: [
        {
          text: 'public.belong',
          key: 'url',
          content: ''
        },
        // {
        //   text: 'public.carrier',
        //   key: 'carrierName'
        // },
        {
          text: 'device.sensor_code',
          key: 'tag_id',
          content: ''
        },
        {
          text: 'device.sensor_type',
          key: 'type',
          content: ''
        },

        {
          text: 'device.sensor_status',
          key: 'status',
          content: ''
        },
        {
          text: 'device.config_status',
          key: 'config_status',
          content: ''
        },
        {
          text: 'public.table_create_time',
          key: 'create_time',
          content: ''
        },
        {
          key: 'nickname',
          text: 'device.nickname',
          content: ''
        },
        {
          key: 'description',
          text: $t('public.table_desc'),
          content: ''
        }
      ],
      detailIsShow: false,
      detailTitle: '',
      // 传感器的基础信息
      detailObj: {},
      // 属性的健名
      deviceType: {},
      // 属性的对应值
      deviceProperty: {},
      detailRuleObj: [
        {
          key: 'collectInterval',
          text: 'device.sample_interval',
          isBool: true
        },
        {
          key: 'exCollectInterval',
          text: 'device.exception_sample_interval',
          isBool: true
        },
        {
          key: 'tempCollectInterval',
          text: $t('integration.temperature_acquisition_interval'),
          isBool: true
        },
        {
          key: 'tempChange',
          text: $t('integration.temperature_change_threshold'),
          isBool: true
        },
        {
          key: 'tempMaxReport',
          text: $t('integration.maximum_temperature_reporting_interval'),
          isBool: true
        },
        {
          key: 'tempMinReport',
          text: $t('integration.minimum_temperature_reporting_interval'),
          isBool: true
        },

        {
          key: 'humCollectInterval',
          text: $t('integration.humidity_collection_interval'),
          isBool: true
        },
        {
          key: 'humChange',
          text: $t('integration.humidity_change_threshold'),
          isBool: true
        },
        {
          key: 'humMaxReport',
          text: $t('integration.maximum_humidity_reporting_interval'),
          isBool: true
        },
        {
          key: 'humMinReport',
          text: $t('integration.humidity_minimum_reporting_interval'),
          isBool: true
        }
      ],
      detailNetObj: [
        {
          key: 'extPanId',
          text: 'Ext Pan ID',
          isBool: true
        },
        {
          key: 'channelPage',
          text: 'Join Attemp',
          isBool: true
        },
        {
          key: 'transmitPower',
          text: 'device.transmit_power',
          isBool: true
        },
        {
          key: 'channelMask',
          text: 'device.channel_mask',
          isBool: true
        },
        {
          key: 'inNetInterval',
          text: 'device.in_net_interval',
          isBool: true
        },
        {
          key: 'devEui',
          text: 'DevEUI',
          isBool: true
        },
        {
          key: 'appEui',
          text: 'AppEUI',
          isBool: true
        },
        {
          key: 'appKey',
          text: 'AppKey',
          isBool: true
        }
      ],
      detailLoading: false,

      isShowCalibration: false,
      isShowCaliImport: false,
      isShowCaliExpired: false,
      singleCalibration: false
    }
  },
  mounted () {
    bus.$off('nodeClickFn')
    bus.$on('nodeClickFn', row => {
      // 获取完整的路径
      this.getAllPath(row)
      console.log(row)
      if (row.id === 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = null
      }
      // 一级范围
      else if (row.level === 0 && row.id !== 'all') {
        this.SearchForm.sceneId = null
        this.SearchForm.scopeName = row.label
      } else {
        this.SearchForm.scopeName = null
        this.SearchForm.sceneId = row.sceneId
      }
      this.getListFn()
    })

    if (getIsPlatform()) {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
      this.treePathObj = this.$store.state.SchemaTree[1].label
    } else {
      this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
      this.treePathObj = this.$store.state.SchemaTree[0].label
    }
    this.getListFn()
    if (this.sysAdmin === 'noSysNoAdmin') {
      this.optareBtn.splice(1, 2)
    }
  },
  methods: {
    searchFn () {
      this.$refs.pager.reset()
      this.SearchForm.iDisplayStart = 0
      this.getListFn()
    },
    /** 分页 */
    getListFn ({ iDisplayStart, iDisplayLength } = {}) {
      if (iDisplayLength) {
        this.SearchForm.iDisplayLength = iDisplayLength
        this.SearchForm.iDisplayStart = iDisplayStart
      }
      this.loading = true
      sensorList(this.SearchForm, this.sensorWay)
        .then(({ result, pageInfo }) => {
          this.tableData = result
          this.total = pageInfo.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 重置 */
    resetFn () {
      this.SearchForm = {
        tagId: null,
        scopeName: null,
        sceneId: null,
        // carrierName: null,
        gatewayName: null,
        sensorType: null,
        status: null,
        configurate: null,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      bus.$emit('initTree')
      if (getIsPlatform()) {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[1].label
        this.treePathObj = this.$store.state.SchemaTree[1].label
      } else {
        this.SearchForm.scopeName = this.$store.state.SchemaTree[0].label
        this.treePathObj = this.$store.state.SchemaTree[0].label
      }

      this.getListFn()
    },
    /** 特殊处理 */
    nodeClick (option) {
      for (const key in this.SearchForm) {
        if (key === 'undefined') {
          delete this.SearchForm[key]
        }
      }
      this.SearchForm.sceneId = option.label.sceneId
      // this.$set(this.SearchForm,'sceneId',option.label.scene_id);
    },
    /** 停用 */
    stopFn () {
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      const idList = this.choozeTableData.map(item => item.id)
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          sensorUpdateStatus(
            qs.stringify({
              ids: idList.join(','),
              status: 2
            })
          ).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 单条停用 */
    stopUseFn (row) {
      this.$confirm(this.$t('public.tip_confirm'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          sensorUpdateStatus(
            qs.stringify({
              ids: row.id,
              status: 2
            })
          ).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getListFn()
          })
        })
        .catch(() => {})
    },
    /** 网络参数& 上报规则 */
    netFn (row) {
      // row.id === 2 为网关  === 3 为规则
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }

      const flag = this.distinguishTypeFn('type')
      if (!flag) {
        return this.$message.error(
          $t(
            'integration.please_select_the_same_temperature_or_temperature_humidity_sensor'
          )
        )
      }

      this.useFuncId = row.id
      console.log(row.id)
      this.useFuncType = this.choozeTableData[0].type
      this.isShow = true

      this.$nextTick(() => {
        this.$refs.vForm.clearValidate()
        // 将dioForm数据init
        const OBJ = this.$refs.vForm.dioForm
        for (const key in OBJ) {
          this.$set(OBJ, key, null)
        }
      })
    },
    /** 区分勾选中的数据是否是同一种类型 */
    distinguishTypeFn (str) {
      if (this.choozeTableData.length === 1) return true

      const oneParam = this.choozeTableData[0]
      let flag = true
      for (const item of this.choozeTableData) {
        if (oneParam.str !== item.str) {
          flag = false
          break
        } else {
          flag = true
        }
      }
      return flag
    },

    choozeTable (row) {
      this.choozeTableData = row
    },

    /** 正在使用的已绑定的配置信息  如果你觉得代码过多  请在对应的表格vue文件书写也行  问题不大 */
    configFn (row) {
      this.isShowConfig = true
      this.useFuncType = row.type
      this.rowData = { ...row }
      this.$nextTick(() => {
        this.$refs.config.activeName = 'rule'
        this.$refs.config.componentContent = 'rule'
        // this.$refs['config'].$refs['componentContent'].isConfig = false;
      })
    },
    changdetail (row) {
      this.detailFn(row)
    },
    /** 详情跳转 */
    detailFn (row) {
      bus.$emit('sensorParam', row.id, row.tagId)
    },
    historyFn (row) {
      const params = sensorHistoryQueryFormat(row)
      sensorHistory(params)
    },
    // 校准
    calibrationFn(){
      if (this.choozeTableData.length === 0) {
        return this.$message.warning(this.$t('public.least_one_data'))
      }
      this.isShowCalibration = true
      this.singleCalibration = false
    },
    calibrationImportFn(){
      this.isShowCaliImport = true
    },
    calibrationExpiredFn(){
      this.isShowCaliExpired = true
    },
    // 单条校准
    calibrationSignleFn(row){
      this.isShowCalibration = true
      this.rowData = { ...row }
      this.singleCalibration = true
    }

  }
}
</script>
<style lang="scss" scoped>
@import '../../../style/sensor.scss';

</style>
